import { TableBody, TableCell, TableRow } from '@/components/ui/table';
import { AlertTriangle } from 'lucide-react';
import type { TableErrorViewProps } from '../types';

export function TableErrorView({ error, columnCount }: TableErrorViewProps) {
  return (
    <TableBody>
      <TableRow>
        <TableCell
          colSpan={columnCount}
          className="px-4 py-6 text-center text-destructive"
        >
          <div className="flex items-center justify-center gap-2">
            <AlertTriangle className="h-4 w-4" />
            {error || 'An error occurred'}
          </div>
        </TableCell>
      </TableRow>
    </TableBody>
  );
}
